import { Controller } from 'react-hook-form';
import { Select, InputText, Autocomplete } from '@ui/src';
import { CardOrderTypes } from './types';

import cn from './card.module.css';

const OrderCardForm = ({
  control,
  errors,
  physical,
  customers,
  cardId,
  countries,
  cardEditId,
  setValue,
}: CardOrderTypes) => (
  <form className={cn.orderCardForm}>
    <div className={cn.orderCardFormTitle}>Order details</div>
    {!cardEditId && (
      <div className={cn.orderCardFormGroup}>
        <Controller
          control={control}
          name="userId"
          render={({ field: { onChange, value } }) => (
            <Select
              list={customers?.map((item) => ({
                name: `${item.firstName} ${item.lastName}`,
                value: item.id,
              }))}
              placeholder="Choose customer"
              name="userId"
              value={value}
              onChange={onChange}
              title="Customer"
              selectWrapperClassName={`${cn.accountFormSelect} ${
                errors?.userId?.message ? cn.accountFormSelectError : ''
              }`}
              disabled={Boolean(cardId)}
            />
          )}
        />
      </div>
    )}

    <div className={cn.orderCardFormGroup}>
      <Controller
        control={control}
        name="paymentSystem"
        render={({ field: { onChange, value } }) => (
          <Select
            list={[
              { name: 'Visa', value: 'Visa' },
              { name: 'MasterCard', value: 'MC' },
              { name: 'UnionPay', value: 'UP' },
            ]}
            placeholder="Choose payment system"
            name="userId"
            value={value}
            onChange={onChange}
            title="Payment system"
            error={errors?.paymentSystem?.message}
          />
        )}
      />
    </div>
    <div className={cn.orderCardFormGroup}>
      <Controller
        control={control}
        name="cardType"
        render={({ field: { onChange, value } }) => (
          <Select
            list={[
              { name: 'Physical', value: 'physical' },
              { name: 'Virtual', value: 'virtual' },
            ]}
            placeholder="Choose payment system"
            name="userId"
            value={value}
            onChange={(e) => {
              onChange(e);

              setValue('physical', Boolean(e.target.value === 'physical'));
            }}
            title="Card type"
            error={errors?.cardType?.message}
          />
        )}
      />
    </div>
    {physical && (
      <>
        <div className={cn.orderCardFormTitle}>Address details</div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="countryId"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                list={countries}
                placeholder="Choose country"
                name="countryId"
                value={value}
                onChange={(e) => {
                  onChange(e);

                  const currentCountry = countries?.find(
                    (item) => item.value === e.target.value,
                  );

                  setValue('countryName', currentCountry?.name);
                }}
                title="Country"
                error={errors?.paymentSystem?.message}
              />
            )}
          />
          <Controller
            control={control}
            name="countryName"
            render={({ field: { value } }) => (
              <input type="hidden" name="countryName" value={value} />
            )}
          />
        </div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="city"
            render={({ field: { onChange, value } }) => (
              <InputText
                name="city"
                placeholder="Enter City"
                onChange={onChange}
                value={value}
                title="City"
                error={errors?.city?.message}
              />
            )}
          />
        </div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="street"
            render={({ field: { onChange, value } }) => (
              <InputText
                name="street"
                placeholder="Enter street"
                onChange={onChange}
                value={value}
                title="Street"
                error={errors?.street?.message}
              />
            )}
          />
        </div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="apartment"
            render={({ field: { onChange, value } }) => (
              <InputText
                name="apartment"
                placeholder="Enter apartment"
                onChange={onChange}
                value={value}
                title="Apartment"
                error={errors?.apartment?.message}
              />
            )}
          />
        </div>
        <div className={cn.orderCardFormGroup}>
          <Controller
            control={control}
            name="postCode"
            render={({ field: { onChange, value } }) => (
              <InputText
                name="postCode"
                placeholder="Enter Post code"
                onChange={onChange}
                value={value}
                title="Post code"
                error={errors?.postCode?.message}
              />
            )}
          />
        </div>
      </>
    )}
  </form>
);

export default OrderCardForm;
